import React from 'react'
import { Row, Col } from 'antd'
import styled from 'styled-components'

const TableGPAX = ({ col, sum, data, data6, point, colorSum, data4 }) => {
  const renderData3 = () => {
    return (
      <Row className='row-table'>
        {data &&
          data.map((item, index) => {
            return (
              <>
                <Col className="small-1" span={8}>
                  <Source3 color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.grade}
                  </Source3>
                </Col>
                <Col className="small-2" span={8}>
                  <Source3 color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.point}
                  </Source3>
                </Col>
                <Col className="small-3" span={8}>
                  <Source3 color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.detail}
                  </Source3>
                </Col>
              </>
            )
          })}
      </Row>
    )
  }

  const renderColumn3 = () => {
    return (
      <Row className='row-table'>
        <Col className="small-1" span={8}>
          <Column>เกรด</Column>
        </Col>
        <Col className="small-2" span={8}>
          <Column>แต้ม</Column>
        </Col>
        <Col className="small-3" span={6}>
          <Column>ความหมาย</Column>
        </Col>
      </Row>
    )
  }

  const renderData6 = (sum) => {
    return (
      <Row className='row-table'>
        {data6 &&
          data6.map((item, index) => {
            return (
              <>
                <Col className="small6-1" span={4}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {index + 1}
                  </Source>
                </Col>
                <Col className="small6-2" span={4}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.subjectID}
                  </Source>
                </Col>
                <Col className="small6-3" span={4}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.unit}
                  </Source>
                </Col>
                <Col className="small6-4" span={4}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.grade}
                  </Source>
                </Col>
                <Col className="small6-5" span={4}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.cout}
                  </Source>
                </Col>
                <Col className="small6-6" span={4}>
                  <Source color={index % 2 === 0 ? '#FFF9EA' : '#fff'}>
                    {item?.gradePoint}
                  </Source>
                </Col>
              </>
            )
          })}
        {sum && point && (
          <>
            <Col className="small6-1" span={4}>
              <Source color={colorSum ? colorSum : '#FFF'} />
            </Col>
            <Col className="small6-2" span={4}>
              <Source color={colorSum ? colorSum : '#FFF'} />
            </Col>
            <Col className="small6-3" span={4}>
              <Source color={colorSum ? colorSum : '#FFF'} />
            </Col>
            <Col className="small6-4" span={4}>
              <Source color={colorSum ? colorSum : '#FFF'}>รวม</Source>
            </Col>
            <Col className="small6-5" span={4}>
              <Source color={colorSum ? colorSum : '#FFF'}>{sum}</Source>
            </Col>
            <Col className="small6-6" span={4}>
              <Source color={colorSum ? colorSum : '#FFF'}>{point}</Source>
            </Col>
          </>
        )}
      </Row>
    )
  }

  const renderData4 = () => {
    return (
      <Row className='row-table'>
        {data4 &&
          data4.map((item, index) => {
            return (
              index < 7 && (
                <>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {index + 1}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.subjectID}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.subject}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.unit}
                    </Source>
                  </Col>
                </>
              )
            )
          })}
      </Row>
    )
  }

  const renderData41 = () => {
    return (
      <Row className='row-table'>
        {data4 &&
          data4.map((item, index) => {
            return (
              index >= 7 &&
              index <= 12 && (
                <>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {index + 1}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.subjectID}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.subject}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.unit}
                    </Source>
                  </Col>
                </>
              )
            )
          })}
      </Row>
    )
  }

  const renderData42 = (sum) => {
    return (
      <Row className='row-table'>
        {data4 &&
          data4.map((item, index) => {
            return (
              index > 12 && (
                <>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {index + 1}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.subjectID}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.subject}
                    </Source>
                  </Col>
                  <Col span={6}>
                    <Source color={index % 2 === 0 ? '#EDEDE' : '#fff'}>
                      {item?.unit}
                    </Source>
                  </Col>
                </>
              )
            )
          })}
      </Row>
    )
  }

  const renderColumn6 = () => {
    return (
      <Row className='row-table'>
        <Col className="small6-1" span={1} />
        <Col className="small6-2" span={4}>
          <Column>รหัสรายวิชา</Column>
        </Col>
        <Col className="small6-3" span={3}>
          <Column>หน่วยกิต</Column>
        </Col>
        <Col className="small6-4" span={4}>
          <Column>เกรด</Column>
        </Col>
        <Col className="small6-5" span={4}>
          <Column>หน่วยกิตที่นับ</Column>
        </Col>
        <Col className="small6-6" span={4}>
          <Column>Grade Point</Column>
        </Col>
      </Row>
    )
  }

  const renderColumn4 = () => {
    return (
      <Row className='row-table'>
        <Col span={6} />
        <Col span={6}>
          <Column>รหัสรายวิชา</Column>
        </Col>
        <Col span={6}>
          <Column>ชื่อวิชา</Column>
        </Col>
        <Col span={6}>
          <Column>หน่วยกิต</Column>
        </Col>
      </Row>
    )
  }

  return (
    <Container>
      {col === 3 ? (
        <div style={{ width: 'auto' }}>
          {renderColumn3()}
          {renderData3()}
        </div>
      ) : col === 4 ? (
        <div style={{ width: 'auto' }}>
          {/* {renderColumn4()} */}
          {renderData4()}
          {/* <NameCourse color='#81000F' align='center' top='50' bottom='32'>
            ภาคการศึกษา 2 - 6 รายวิชา
          </NameCourse> */}
          {/* {renderColumn4()} */}
          {renderData41()}

          {/* <NameCourse color='#81000F' align='center' top='50' bottom='32'>
            ภาคการศึกษา 3 - 6 รายวิชา
          </NameCourse> */}
          {renderData42()}
        </div>
      ) : (
        <div style={{ width: 'auto' }}>
          {renderColumn6()}
          {renderData6(sum, point)}
        </div>
      )}
    </Container>
  )
}

export default TableGPAX

export const Container = styled.div`
  overflow-x: scroll;
  overflow-y: hidden;
  margin-bottom: 10%;
  max-width: 1050px;

  .row-table {
    width: 100%;
    @media only screen and (max-width: 667px) {
      width: 667px !important;
    }

    @media only screen and (max-width: 820px) {
      width: 820px;
    }

    @media only screen and (min-width: 1440px) {
      .small-1.ant-col-8 {
        flex: 0 0 25% !important;
        max-width: 25% !important;
      }
      .small-2.ant-col-8 {
        flex: 0 0 25% !important;
        max-width: 25% !important;
      }
      .small-3.ant-col-8 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }

      .small6-1.ant-col-4{
        flex: 0 0 4.16666667% !important;
        max-width: 4.16666667% !important;
      }
      .small6-3.ant-col-4{
        flex: 0 0 12.5% !important;
        max-width: 12.5% !important;
      }
      .small6-2.ant-col-4{
        flex: 0 0 25% !important;
        max-width: 25% !important;
      }
      .small6-6.ant-col-4{
        flex: 0 0 25% !important;
        max-width: 25% !important;
      }
    }
  }
`

export const Column = styled.p`
  font-family: 'Noto Sans Thai Bold';
  line-height: 25px;
  font-size: clamp(16px, 2vw, 24px);
  text-align: left;
  color: var(--black);
  background-color: ${(props) => (props.color ? props.color : 'var( --white)')};
  padding: 10px 20px;
  margin-bottom: 0;
`

export const Source3 = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 25px;
  font-size: clamp(12px, 2vw, 24px);
  text-align: left;
  color: var(--black);
  background-color: ${(props) => (props.color ? props.color : 'var( --white)')};
  padding: 10px 20px;
  margin-bottom: 0;
`

export const Source = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 25px;
  font-size: clamp(12px, 2vw, 24px);
  margin: 0;
  text-align: left;
  color: var(--black);
  padding: 10px 20px;
  background-color: ${(props) => (props.color ? props.color : 'var( --white)')};
  min-height: 100%;
`

export const NameCourse = styled.p`
  font-family: 'Noto Sans Thai';
  text-align: ${(props) => (props.align ? props.align : 'left')};
  font-size: clamp(20px, 2.5vw, 24px);
  line-height: 30px;
  margin-left: ${(props) =>
    props.left ? `${props.left}px` : '5px'} !important;
  margin-bottom: ${(props) => (props.bottom ? `${props.bottom}px` : '2px')};

  color: ${(props) => (props.color ? props.color : 'var(--black)')};

  min-height: ${(props) =>
    props.height ? `${props.height}px` : '50px'} !important;
  margin-top: ${(props) => (props.top ? `${props.top}px` : '20px')};

  @media screen and (max-width: 414px) {
    min-height: 10px !important;

  }

  @media screen and (max-width: 1440px) {
    min-height: auto !important;
  }
  @media only screen and (min-width: 1440px) {
    min-height: auto !important;
  }

  @media only screen and (max-width: 1024px) and (orientation: portrait) {
    line-height: 28px !important;

  }

  @media only screen and (width: 1024px) and (orientation: portrait) {
    min-height: auto !important;
  }
`
